import {
	TOGGLE_ADD_OPERATOR_DIALOG,
	GET_OPERATORS,
	SET_FORM_STATE,
	NAVIGATE_DETAILS,
	GET_OPERATOR,
	TOGGLE_ADD_PROJECT_DIALOG
} from '../actions/OperatorsActions.js';

const initialState = {
	operators: [],
	openAddOperatorDialog: false,
	detailsOperatorId: null,
	operator: {},
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
	openAddProjectDialog: false,
};

const operatorsReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_OPERATORS: {
						return {
							...state,
							operators: action.operators
						};
					}
					case TOGGLE_ADD_OPERATOR_DIALOG: {
						return {
							...state,
							openAddOperatorDialog: action.openAddOperatorDialog,
							formState: initialState.formState
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case NAVIGATE_DETAILS: {
						return {
							...state,
							detailsOperatorId: action.detailsOperatorId
						};
					}
					case GET_OPERATOR: {
						return {
							...state,
							operator: action.operator,
							formState: {
								...state.formState,
								values: { ...action.operator }
							}
						};
					}
					case TOGGLE_ADD_PROJECT_DIALOG: {
						return {
							...state,
							openAddProjectDialog: action.openAddProjectDialog,
							formState: initialState.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default operatorsReducer;
